"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _DeviceConstants = require("./DeviceConstants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* uses the inline padding hack for IE11\n  * url: https://css-tricks.com/scale-svg/#article-header-id-11 */\n  height: 1px;\n  overflow: visible !important;\n  padding-bottom: ", ";\n  pointer-events: none;\n  position: relative;\n  vertical-align: bottom; /* for IE11 */\n  width: 100%;\n  z-index: 1;\n\n  @supports (display: grid) {\n    height: auto;\n    padding-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledTemplate = (0, _styledComponents.default)(function (props) {
  var __dimensions = props.dimensions,
      Template = props.Template,
      rest = (0, _objectWithoutProperties2.default)(props, ["dimensions", "Template"]);
  return _react.default.createElement(Template, rest);
}).attrs({
  preserveAspectRatio: 'xMidYMin slice',
  viewBox: function viewBox(props) {
    return "0 0 " + props.dimensions.width + " " + props.dimensions.height;
  },
  xmlns: 'http://www.w3.org/2000/svg'
}).withConfig({
  displayName: "AbstractDeviceTemplate__StyledTemplate",
  componentId: "sc-1eatywg-0"
})(_templateObject(), function (props) {
  return (0, _DeviceConstants.toScaledPercentage)(props.dimensions, 'height');
});

var AbstractDeviceTemplate = function AbstractDeviceTemplate(props) {
  var dimensions = props.dimensions,
      Template = props.Template,
      rest = (0, _objectWithoutProperties2.default)(props, ["dimensions", "Template"]);
  return _react.default.createElement(StyledTemplate, (0, _extends2.default)({}, rest, {
    Template: Template,
    dimensions: dimensions
  }));
};

AbstractDeviceTemplate.propTypes = {
  children: _react.PropTypes.node,
  dimensions: _react.PropTypes.shape({
    Template: _component.default.isRequired,
    top: _react.PropTypes.number.isRequired,
    right: _react.PropTypes.number.isRequired,
    bottom: _react.PropTypes.number.isRequired,
    left: _react.PropTypes.number.isRequired,
    height: _react.PropTypes.number.isRequired,
    width: _react.PropTypes.number.isRequired
  }),
  Template: _component.default
};
AbstractDeviceTemplate.defaultProps = {
  Template: StyledTemplate
};
var _default = AbstractDeviceTemplate;
exports.default = _default;
module.exports = exports.default;